/**
 * Set up tabs
 *
 * Sets up accessibility and behavior for tabs. Can work with either
 * one list of label toggles, or multiple (e.g. if goes from a tab
 * nav to an accordion at mobile).
 *
 * Example:

// single nav
tabs('my-tabs', {
	wrap: '.my-tabs',
	toggles: '.my-tabs__nav-label',
	content: '.my-tabs__content',
});

// or for multiple nav
tabs('my-tabs', {
	wrap: '.my-tabs',
	toggles: ['.my-tabs__nav-label', '.my-tabs__acc-label'],
	content: '.my-tabs__content',
});

 *
 */


const tabs = (name, selectors) => {

	const tabWraps = document.querySelectorAll(selectors.wrap);
	if(tabWraps){
		tabWraps.forEach((tab, i) => {

			// set up content sections
			const id = `${name}-${i}`;
			const content = tab.querySelectorAll(selectors.content);
			const amount = content.length;

			// set up toggles
			let togglesArr = [];
			const toggleSelectors = 'string' === typeof selectors.toggles ? [selectors.toggles] : selectors.toggles;
			toggleSelectors.forEach(toggleSelector => {
				const sluggish = toggleSelector.replace(/[^a-zA-Z ]/g, '');
				togglesArr.push({
					sluggish,
					el: tab.querySelectorAll(toggleSelector),
				});
			});

			// handle clicks
			const setTab = (index) => {
				togglesArr.forEach((toggles) => {
					toggles.el.forEach((el, i) => el.setAttribute('aria-selected', i === index));
				});
				content.forEach((el, i) => {
					el.setAttribute('aria-hidden', i !== index);
					el.setAttribute('tabindex', i !== index ? -1 : 0);
				});
			}

			// loop each item using content number as assumed amount
			for(let j = 0; j < amount; j++) {

				// set up this particular iteration's ID
				const subId = `${id}-${j}`;

				// apply accessibility to content
				content[j].setAttribute('id', subId);
				content[j].setAttribute('aria-hidden', !!j); // applies to all but first item
				content[j].setAttribute('role', 'tabpanel');
				content[j].setAttribute('tabindex', !j ? 0 : -1);

				// set up the toggle(s)
				togglesArr.forEach((toggles, i) => {
					const toggleId = `${toggles.sluggish}-${subId}`;
					toggles.el[j].setAttribute('id', toggleId);
					toggles.el[j].setAttribute('role', 'tab');
					toggles.el[j].setAttribute('aria-controls', `${subId}`);
					toggles.el[j].setAttribute('aria-selected', !j); // applies to first item
					toggles.el[j].addEventListener('click', () => setTab(j));
					// only set labelledby of content based on first controls found (index 0)
					if(!i) {
						content[j].setAttribute('aria-labelledby', toggleId);
					}
				});

			}

		});
	}

}

export default tabs;

